import { t } from "@/i18n-js/instance";
import { FormTipTapEditor } from "@/react/components/shared/BuilderUI/Editor/fields/RichTextField/FormTiptapEditor";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { Form } from "@circle-react-uikit/Form";

export const ContentEditor = () => {
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  return (
    <div
      className={classNames({
        "px-6": !isPropertiesPanelV2,
        "flex flex-col gap-3 px-6 py-4": isPropertiesPanelV2,
      })}
    >
      <Form.Item
        name="text"
        label={t("builder_ui.prop_type.text")}
        hideBorder
        hideDescription
        labelClassName={classNames({
          "!text-dark !text-xs !font-normal": isPropertiesPanelV2,
        })}
        className={classNames({
          "!p-0": isPropertiesPanelV2,
        })}
      >
        <FormTipTapEditor name="text" />
      </Form.Item>
      <Form.Item
        name="href"
        label={t("builder_ui.prop_type.link")}
        hideBorder
        hideDescription
        labelClassName={classNames({
          "!text-dark !text-xs !font-normal": isPropertiesPanelV2,
        })}
        className={classNames({
          "!p-0": isPropertiesPanelV2,
        })}
      >
        <Form.Input name="href" data-testid="builder-ui-href-input" />
      </Form.Item>
    </div>
  );
};
